import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { getTaux } from '../../data/tarifsData';
import './Shop.css';

const DEVISES = [
  { key: 'fcfa', label: 'FCFA' },
  { key: 'usd',  label: 'USD'  },
  { key: 'eur',  label: 'EUR'  },
];

// Formate un montant FCFA dans la devise choisie, avec le taux live —
// même logique que Tarifs.jsx / Digitalisation.jsx / Services.jsx,
// pour que le même prix FCFA donne toujours le même montant converti
// partout sur le site.
function fmt(fcfa, devise, TAUX) {
  if (fcfa == null) return 'Sur devis';
  if (devise === 'usd') return Math.round(fcfa / TAUX.USD).toLocaleString('fr-FR') + ' $';
  if (devise === 'eur') return Math.round(fcfa / TAUX.EUR).toLocaleString('fr-FR') + ' €';
  return Number(fcfa).toLocaleString('fr-FR') + ' FCFA';
}

function unitLabel(unit) {
  if (unit === 'mois')    return '/ mois';
  if (unit === 'analyse') return '/ analyse';
  if (unit === 'unique')  return '(paiement unique)';
  return '';
}

function TypeBadges({ types, essaiGratuit }) {
  if (!types) return null;
  const chips = [];
  if (types.achat)      chips.push(['🛍 Achat direct', '#00BFFF']);
  if (types.abonnement) chips.push(['🔁 Abonnement', '#00CC88']);
  if (types.entretien)  chips.push(['🛠 Entretien inclus', '#D4A017']);
  if (essaiGratuit && types.abonnement) chips.push(['🎁 1 mois d\'essai gratuit', '#FF9F1C']);
  if (chips.length === 0) return null;
  return (
    <div className="shop-type-chips">
      {chips.map(([label, color]) => (
        <span key={label} className="shop-type-chip" style={{ color, borderColor: color + '55', background: color + '14' }}>
          {label}
        </span>
      ))}
    </div>
  );
}

function ProductCard({ p, devise, TAUX }) {
  const { addToCart, setShowCart, showToast } = useApp();
  const [open, setOpen] = useState(false);

  function handleAdd() {
    addToCart(p, 1);
    showToast(`${p.name} ajouté au panier`, 'ok');
  }

  function handleBuyNow() {
    addToCart(p, 1);
    setShowCart(true);
  }

  return (
    <div className="shop-card">
      {p.badge ? <div className="shop-badge">{p.badge}</div> : null}
      <div className="shop-card-top">
        {p.iconImage
          ? <img src={p.iconImage} alt={p.name} className="shop-icon-img" />
          : <div className="shop-icon">{p.icon}</div>}
        <div>
          <div className="shop-name">{p.name}</div>
          <div className="shop-desc">{p.desc}</div>
        </div>
      </div>

      <TypeBadges types={p.types} essaiGratuit={p.essaiGratuit} />

      {open && p.longDesc && (
        <div className="shop-longdesc">{p.longDesc}</div>
      )}
      <button className="shop-more" onClick={() => setOpen(o => !o)}>
        {open ? '▲ Masquer la description' : '▾ Lire la description'}
      </button>

      <div className="shop-card-foot">
        <div>
          {p.onDevis ? (
            <div className="shop-price shop-price-devis">Sur devis</div>
          ) : (
            <>
              <div className="shop-price">
                {fmt(p.priceFcfa, devise, TAUX)} <span className="shop-unit">{unitLabel(p.unit)}</span>
              </div>
              {p.priceFcfaMax > p.priceFcfa && (
                <div className="shop-price-range">jusqu'à {fmt(p.priceFcfaMax, devise, TAUX)} selon besoins</div>
              )}
            </>
          )}
        </div>

        {p.onDevis ? (
          <a href="#contact" className="shop-btn shop-btn-outline">Demander un devis →</a>
        ) : (
          <div className="shop-btns">
            <button className="shop-btn shop-btn-outline" onClick={handleAdd}>🛒 Ajouter</button>
            <button className="shop-btn shop-btn-buy" onClick={handleBuyNow}>⚡ Acheter maintenant</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Shop() {
  const { data, cartCount, setShowCart } = useApp();
  const produits = (data.produits || []).filter(p => p.active !== false);
  const [devise, setDevise] = useState('fcfa');

  // Taux live — même source que partout ailleurs sur le site.
  const TAUX = getTaux(data.tauxChange || {});

  if (produits.length === 0) return null;

  return (
    <section className="ms bg2" id="boutique">
      <div className="sh">
        <div className="stag">🛒 KotosShop</div>
        <h2 className="stitle">Nos Applications, Prêtes à l'Emploi</h2>
        <p className="sdesc">
          Découvrez, ajoutez au panier et payez en ligne en toute sécurité — sans quitter notre site.
          Paiement Mobile Money &amp; carte bancaire via FedaPay.
        </p>

        {/* Sélecteur devise */}
        <div className="dig-devise-btns" style={{ marginTop: '18px' }}>
          {DEVISES.map(d => (
            <button
              key={d.key}
              className={`dig-devise-btn ${devise === d.key ? 'active' : ''}`}
              onClick={() => setDevise(d.key)}
            >
              {d.label}
            </button>
          ))}
        </div>
      </div>

      <div className="shop-toolbar">
        <span className="shop-toolbar-txt">{produits.length} application(s) disponible(s)</span>
        <button className="shop-cart-mini" onClick={() => setShowCart(true)}>
          🛒 Mon panier {cartCount > 0 && <span className="shop-cart-badge">{cartCount}</span>}
        </button>
      </div>

      <div className="shop-grid">
        {produits.map(p => <ProductCard key={p.id} p={p} devise={devise} TAUX={TAUX} />)}
      </div>
    </section>
  );
}